import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const translate = inject(TranslateService);
  const lang = translate.currentLang;
  if (lang) {
    req = req.clone({
      setHeaders: {
        'X-Preferred-Language': lang,
      },
    });
  }
  return next(req);
};
